const BACKEND_API = process.env.REACT_APP_BACKEND_API || 'http://localhost:4001/api';

// Phase 2 of the httpOnly-cookie migration (see backend/src/lib/authToken.js) —
// credentials: 'include' sends the bescom_token cookie automatically when
// one exists; when it doesn't (Register.jsx/ClaimAccount.jsx polling
// before any session exists — see profile.js's own header comment), the
// browser simply has nothing to send, same "no session" outcome the old
// authHeaders() helper produced by finding nothing in localStorage.

export const getHierarchy = async () => {
  const res = await fetch(`${BACKEND_API}/hierarchy`);
  const data = await res.json();
  return data.hierarchy || [];
};

export const saveHierarchy = async (hierarchy) => {
  const res = await fetch(`${BACKEND_API}/hierarchy`, {
    method: 'PUT',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ hierarchy }),
  });
  return res.json();
};

// Retroactively applying a hierarchy edit to existing accounts (see
// hierarchy.js's own header comment on these two routes) — a preview
// (how many accounts, read-only) and the actual update, kept as two
// separate calls so AdminHierarchy.jsx can show the real count before an
// admin commits to a bulk account-attribute rewrite.
export const getHierarchyAffectedAccounts = async (entry) => {
  const params = new URLSearchParams({
    zone: entry.zone || '', circle: entry.circle || '', division: entry.division || '',
    subdivision: entry.subdivision || '', section: entry.section || '',
  });
  const res = await fetch(`${BACKEND_API}/hierarchy/affected-accounts?${params.toString()}`, {
    credentials: 'include',
  });
  return res.json();
};

export const cascadeUpdateHierarchy = async (oldEntry, newEntry) => {
  const res = await fetch(`${BACKEND_API}/hierarchy/cascade-update`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ oldEntry, newEntry }),
  });
  return res.json();
};

export const getUserByUsername = async (username) => {
  const res = await fetch(`${BACKEND_API}/profile/user/${username}`, {
    credentials: 'include',
  });
  return res.json();
};

export const getUserProfile = async (userPk) => {
  const res = await fetch(`${BACKEND_API}/profile/user/${userPk}/profile`, {
    credentials: 'include',
  });
  return res.json();
};

export const saveUserProfile = async (userPk, profile) => {
  const res = await fetch(`${BACKEND_API}/profile/user/${userPk}/profile`, {
    method: 'PATCH',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(profile),
  });
  return res.json();
};
